import router from "next/router";

import { Link as LinkType } from "../types/Link";

const linkPrefix = process.env.LINK_PREFIX || "";

export function routerPush(path: string, query: any = {}) {
  const r = withPrefix(path, query);
  router.push(r.href, r.as);
}

export function withPrefix(path: string, query: any = {}): LinkType {
  // Ensure we don't duplicate the linkPrefix if path already starts with it
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  const prefixedPath = normalizedPath.startsWith(linkPrefix.replace(/^\//, ""))
    ? `/${normalizedPath}${normalizedPath ? "/" : ""}`
    : `${linkPrefix}/${normalizedPath ? normalizedPath + "/" : normalizedPath}`;

  return {
    href: {
      pathname: `/${path}`,
      query,
      // @ts-ignore
      origin: global && global.location && global.location.origin,
    },
    as: {
      pathname: prefixedPath,
      query,
    },
  };
}
